import { useMutation, useQueryClient } from '@tanstack/react-query';
import { switchAdminContext } from '../services/api.ts';
import toast from 'react-hot-toast';

export const useContextSwitch = () => {
  const queryClient = useQueryClient();

  const switchContext = useMutation({

    mutationFn: (context) => switchAdminContext(context),
    onSuccess: () => {
      toast.success('Context switched successfully');
      // Invalidate and refetch profile data to update admin status
      queryClient.invalidateQueries({ queryKey: ['profile'] });
      // Reload the page to reflect the new context
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    },
    onError: (error: any) => {
      const errorMessage = error.response?.data?.message || 'Failed to switch context. Please try again.';
      toast.error(errorMessage);
    },
  });

  return {
    switchContext,
    isSwitching: switchContext.isPending,
  };
}; 